import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import Utils from "models/helper/Utils";
import AlbumsTabContentCollection from "collections/myLibrary/AlbumsTabContentCollection";
import AlbumListView from "views/common/AlbumListView";
import PersistentModels from "services/PersistentModels";
import PlayerService from "services/PlayerService";
import RSVP from "rsvp";

const AlbumListController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        if(options)
        {
            if(options.model)
            {
                if(Utils.getInstance().is("Array",options.model))
                {
                    const albumJsonArray = options.model;
                    this.model = new AlbumsTabContentCollection(albumJsonArray);
                }else{
                        this.model = options.model;
                }
                
            }
            if(options.resizePlaceHolderElem)
            {
                this.resizePlaceHolderElem = options.resizePlaceHolderElem;
            }else{
                this.resizePlaceHolderElem = false;
            }
            
            if(options.loadHandler)
            {
                this._loadHandler = options.loadHandler;
            }
            if(options.heightMargin){
                this._heightMargin = options.heightMargin;
            }
        
        }
    },

    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },
    
    
    updateListOfAlbums : function(arrayOfAlbumJson){
        this.model.reset(arrayOfAlbumJson/*, {silent: true}*/);
    },

    showAlbumDetailsPage : function(albumModel){
        PersistentModels.getInstance().getRouter().showAlbumDetailPage(albumModel.get("albumId") , albumModel, true);
    },
    
    addSongsAlbumToQueue :function(album){
        //this.trigger("addAlbumToEndOfQueue",this.model.where({uri:songModelSwiped.uri}));
        const songURIs = [];
        const songsJson = album.get("songs");
        for(let songIndex in songsJson)
        {
            songURIs.push(songsJson[songIndex].uri)
        }
        if(songURIs.length > 0){
            PlayerService.getInstance().addSongsToQueue(PersistentModels.getInstance().getSongCollection().getSongsWithURI(songURIs));
        }
    },
    
    showMenuOption : function(albumModel){
        PersistentModels.getInstance().getRouter().showAlbumOptionPopup(albumModel);
    },
    
    cancelPendingImageLoading : function(){
        this.view.cancelPendingImageLoading();
    },
    buildModelAndRenderView : function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                if(!this.model)
                {
                    this.model = new AlbumsTabContentCollection([]);
                }
                this.view = new AlbumListView({
                    "collection" : this.model,
                    "delayOnCollectionUpdate" : 1000,
                    "resizeToAvailableScreenSizeOnOrientationChange" : false,
                    "resizePlaceHolderElem" : this.resizePlaceHolderElem,
                    "loadHandler" : this._loadHandler,
                    "heightMargin": this._heightMargin,
                });
                this.listenTo(this.view, "itemTaped",this.showAlbumDetailsPage);
                this.listenTo(this.view, "itemSwipedRight",this.addSongsAlbumToQueue);
                this.listenTo(this.view, "itemOptionBtnTapped", this.showMenuOption);
                this.view.render();
                resolve();
            } catch (error) {
                reject(error);
            }

        }).bind(this));

    }

});

export default AlbumListController;